import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls to top on every route change. Drop-in for React Router.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // instant — jumping straight to top feels "correct" on navigation,
    // whereas smooth-scroll feels sluggish for multi-screen pages
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
